import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=2caca842&scoped=true"
import script from "./PageTabs.vue?vue&type=script&lang=js"
export * from "./PageTabs.vue?vue&type=script&lang=js"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=2caca842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caca842",
  null
  
)

export default component.exports